// config.ts
interface Config {
    apiUrl: string;
    environment: 'development' | 'production';
  }
  
  // Check if we're in production by looking at the hostname
  const isProduction = window.location.hostname !== 'localhost' && 
                      window.location.hostname !== '127.0.0.1' &&
                      !window.location.hostname.includes('localhost');
  
  const API_URL_DEVELOPMENT = 'http://localhost:8080/api/v1';
  const API_URL_PRODUCTION = 'https://clip-sense-platform-380511447595.us-central1.run.app/api/v1';
  
  // Ensure HTTPS is always used in production
  const getApiUrl = () => {
    if (isProduction) {
      // Force HTTPS for production
      const url = API_URL_PRODUCTION;
      if (!url.startsWith('https://')) {
        console.warn('Production API URL should use HTTPS, forcing HTTPS');
        return url.replace('http://', 'https://');
      }
      return url;
    }
    return API_URL_DEVELOPMENT;
  };
  
  const config: Config = {
    apiUrl: getApiUrl(),
    environment: isProduction ? 'production' : 'development'
  };
  
  // This console log is key to debugging what URL is *actually* being used
  console.log('Environment:', config.environment);
  console.log('API URL:', config.apiUrl);
  console.log('Hostname:', window.location.hostname);
  console.log('Is Production:', isProduction);
  console.log('Protocol:', window.location.protocol);
  
  export default config;
  